import React, {forwardRef} from 'react';
import {Icon} from 'bonprix-design-system';

const HeaderVoucher = forwardRef(function HeaderVoucher(
    {onClick, ariaControls = 'voucher-dialog', showBadge = false},
    ref,
) {
    return (
        <button
            ref={ref}
            className="header__icon-box voucher-button"
            title="Gutscheine & Rabatte"
            type="button"
            onClick={onClick}
            aria-haspopup="dialog"
            aria-controls={ariaControls}
        >
            <div className="header__icon-with-badge">
                <Icon variant="voucher" className={'fill-current'} />
                {showBadge && <span className="header-icon__badge" aria-hidden="true"></span>}
            </div>
        </button>
    );
});

export default HeaderVoucher;
